"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawAll = exports.seBorderColor = exports.get = void 0;
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueGlyphs_sidecar_1 = require("../targeting/rogueGlyphs-sidecar");
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            borderColor: rogueDef_sidecar_1.rogueDef.colors.brown,
        };
    }
    return _obj;
};
exports.get = get;
var seBorderColor = function (color) {
    var obj = (0, exports.get)();
    obj.borderColor = color;
};
exports.seBorderColor = seBorderColor;
var drawAll = function () {
    var obj = (0, exports.get)();
    for (var i = 0; i < rogueDef_sidecar_1.rogueDef.screenWidth; i++) {
        rogueGlyphs_sidecar_1.rogueGlyphs.writeBg(i, 0, obj.borderColor);
        rogueGlyphs_sidecar_1.rogueGlyphs.writeBg(i, rogueDef_sidecar_1.rogueDef.screenHeight - 1, obj.borderColor);
    }
    for (var j = 0; j < rogueDef_sidecar_1.rogueDef.screenHeight; j++) {
        rogueGlyphs_sidecar_1.rogueGlyphs.writeBg(0, j, obj.borderColor);
        rogueGlyphs_sidecar_1.rogueGlyphs.writeBg(rogueDef_sidecar_1.rogueDef.screenWidth - 1, j, obj.borderColor);
    }
};
exports.drawAll = drawAll;
